<template>
<!-- 搜索出内容数据组件 -->
<van-tabs v-model="active" color="#F8D541" line-width="30px" sticky offset-top="51" swipeable>
  <van-tab title="内容">
    <div class="search_content" v-if="list.length>0">
      <Waterfall :minCol="2" :maxCol="2" :percent="[1,1]" :gutterHeight="10" :width="itemWidth" :gutterWidth="gutterWidth">
        <itemContent v-for="(item,index) in list" :key="index" />
      </Waterfall>
    </div>
    <div v-else><emptyItem info="暂没有找到内容，换个词在搜一遍吧！"/></div>
  </van-tab>
  <van-tab title="蜜蜂">
    <div v-if="bees.length>0">
      <beeItem v-for="(item,index) in bees" :key="index"/>
    </div>
    <div v-else><emptyItem info="暂没有找到蜜蜂，换个词在搜一遍吧！"/></div>
  </van-tab>
</van-tabs>  
</template>
<script>
import beeItem from './beeItem'
import emptyItem from './emptyItem'
import { Waterfall } from "vue2-waterfall";
import itemContent from './itemContent'
export default {
  data(){
    return{
      active:0,
      list:[],
      bees:[]
    }
  },
  props:{
    value:{
      default:'',
      type:String,
      required:true
    }
  },
  components:{
    beeItem,
    itemContent,
    Waterfall,
    emptyItem
  },
  methods:{
    getData(){
      console.log('val=>',this.value)
    }
  },
  watch:{
    'value':function(val,oldval){
      console.log('val',val)
    }
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  }
}
</script>
<style lang="less" scoped>
  .search_content{
    padding: 20px;
    // background: #fff;
  }
</style>